import axios from "axios";
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// HR LEAVE REQUEST VERIFICATION RELATED APIs
// ==============================================

// 1. Get Verify Leave Requests Inbox (GET)
export const getVerifyLeaveRequests = async (params) => {
    try {
        const { roleId } = params;
         // DEBUG
        
        // Validate required parameters
        if (!roleId) {
            throw new Error('RoleID is required');
        }
        
        const queryParams = new URLSearchParams({
            RoleId: roleId.toString().trim()
        });
        
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetVerifyLeaveRequests?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get Single Employee for Leave Request (GET)
export const getSingleEmpForLeaveRequest = async (params) => {
    try {
        const { empRefno } = params;
         // DEBUG
        
        // Validate required parameters
        if (!empRefno) {
            throw new Error('EmpRefno is required');
        }
        
        const queryParams = new URLSearchParams({
            EmpRefno: empRefno.toString().trim()
        });
        
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetSingleEmpForLeaveRequest?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. Approve HR Leave Request (PUT)
export const approveHRLeaveRequest = async (params) => {
    try {
         // DEBUG
        
        // Validate required parameters
        if (!params.EmpRefNo) {
            throw new Error('EmpRefNo is required');
        }
        if (!params.TransactionRefNo) {
            throw new Error('TransactionRefNo is required');
        }
        if (!params.Roleid) {
            throw new Error('Roleid is required');
        }
        if (!params.Action) {
            throw new Error('Action is required');
        }
        if (!params.CreatedBy) {
            throw new Error('CreatedBy is required');
        }
        if (!params.UserName) {
            throw new Error('UserName is required');
        }
        if (!params.Noofleaves) {
            throw new Error('Noofleaves is required');
        }
        if (!params.LeaveTypeId) {
            throw new Error('LeaveTypeId is required');
        }
        if (!params.JoiningCostCenter) {
            throw new Error('JoiningCostCenter is required');
        }
        if (!params.FromDate) {
            throw new Error('FromDate is required');
        }
        if (!params.ToDate) {
            throw new Error('ToDate is required');
        }
        
        const payload = {
            EmpRefNo: params.EmpRefNo.toString().trim(),
            TransactionRefNo: params.TransactionRefNo.toString().trim(),
            Roleid: parseInt(params.Roleid),
            Action: params.Action.toString().trim(),
            Note: params.Note?.toString().trim() || '',
            CreatedBy: params.CreatedBy.toString().trim(),
            UserName: params.UserName.toString().trim(),
            Noofleaves: parseInt(params.Noofleaves),
            LeaveTypeId: parseInt(params.LeaveTypeId),
            JoiningCostCenter: params.JoiningCostCenter.toString().trim(),
            FromDate: params.FromDate.toString().trim(),
            ToDate: params.ToDate.toString().trim(),
            Remarks: params.Remarks?.toString().trim() || '',
            SubmitAction: params.SubmitAction?.toString().trim() || 'CheckLeaves'
        };
        
         // DEBUG
         // DEBUG
        
        const response = await axios.put(
            `${API_BASE_URL}/HR/ApproveHRLeaveRequest`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};
// ==============================================
// HR LEAVE REQUEST CREATION RELATED APIs
// ==============================================

// 4. Get Employee Data for Leave Request (search autocomplete)
export const getEmpDataForLeaveRequest = async (prefix) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetEmpDataForLeaveRequest?Prefix=${encodeURIComponent(prefix)}`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error;
    }
};

// 5. Get Employee Balance Leave
export const getEmpBalanceLeave = async (params) => {
    try {
        const { empRefno, leaveTypeid, fromDate } = params;
        const queryParams = new URLSearchParams({
            EmpRefno: empRefno,
            LeaveTypeid: leaveTypeid,
            FromDate: fromDate,
        });
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetEmpBalanceLeave?${queryParams}`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error;
    }
};

// 6. Save HR Leave Request (POST)
export const saveHRLeaveRequest = async (data) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/HR/SaveHRLeaveRequest`,
            data,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error;
    }
};

// 7. Get Leave Request by Refno (POST)
export const getLeaveRequestByRefno = async (data) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/HR/GetLeaveRequestbyRefno`,
            data,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error;
    }
};
